// Coloured initials tiles for follow-up customers (list + detail)
const AVATAR_COLOURS = [
  ['#1f4d3a', '#6ee7a8'],
  ['#3d2f63', '#c4b5fd'],
  ['#5c2741', '#f9a8d4'],
  ['#5a4313', '#fcd34d'],
  ['#1e3a5f', '#93c5fd'],
  ['#374151', '#d1d5db'],
];

export const avatarColours = (name) =>
  AVATAR_COLOURS[[...(name || '')].reduce((n, c) => n + c.charCodeAt(0), 0) % AVATAR_COLOURS.length];

export const initials = (name) =>
  (name || '?').split(' ').filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join('');
